
/**
 * @nullable
 */
export type CreateNotification201Data = {[key: string]: unknown} | null;
